import { useTrail, animated, useSpring, useSprings } from "@react-spring/web";
import { cardImages, cardBackCover } from "../CardImages";
import { HubConnectionBuilder, HttpTransportType } from "@microsoft/signalr";
import OpptGameBoard from "../../assets/Game/GinRummy/images/oppoGame_board.png";
import GinGameImage from "../../assets/Game/GinRummy/images/GinGame_image.png";
import GameBoard from "../../assets/Game/GinRummy/images/userGame_board.png";
import PlayerBoard from "../../assets/Game/GinRummy/images/playerBoard.png";
import User from "../../assets/Game/GinRummy/images/user.png";
import { useNavigate } from "react-router-dom";
import ExitBtn from "../../assets/Game/GinRummy/images/Exit.png";
import { cloneDeep } from "lodash";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ".././cardModule.css";
import Button from "../GinGame/Button/Button";
import { useDisplayCardsQuery } from "../../features/UserFeatures/Cards/cardsSave/CardsSlice";
import GinGameScore from "../ModalPopup/GinGameScore";
import GinGameKnock from "../ModalPopup/GinGameKnock";
import Swal from "sweetalert2";
import { useLazyGetScoreQuery, useScoreMutation, useViewScoreQuery } from "../../features/UserFeatures/Cards/Score/ScoreSlice";
import GinGameWinPage from "../ModalPopup/GinGameWinPage";
import Loader from "../Loader/Loader";
import Timer from "../CountdownTimer/Timer";
import { useSavePlayersCardMutation, useShowPlayersCardMutation, useUpdatePlayersCardMutation } from "../../features/UserFeatures/Cards/cardsSave/CardsSaveSlice";


const Cards = () => {
  const [createScore] = useScoreMutation();
  const [savePlayerCards] = useSavePlayersCardMutation();
  const botId = "jarvis123";
  const gameName = "GinRummy";
  const [show, setShow] = useState(false);
  const [connection, setConnection] = useState(null);
  const [cardLength, setCardLength] = useState(false);
  const [oppoCardLength, setOppoCardLength] = useState(false);
  const [deckPileNewLength, setDeckPileNewLength] = useState();
  const [deadValue, setDeadValue] = useState();
  const [botDeadValue, setBotDeadValue] = useState();
  const [botPickData, setBotPickData] = useState([]);
  const [animatedI, setAnimatedI] = useState(null);
  const [animatedI2, setAnimatedI2] = useState(false);
  const [animatedI3, setAnimatedI3] = useState(false);
  const [animatedI4, setAnimatedI4] = useState(null);
  const [animatedI5, setAnimatedI5] = useState(null);
  const [animatedI6, setAnimatedI6] = useState(false);
  const [borderI, setBorderI] = useState({ i: null, style: "" });
  const [knockTrue, setKnockTrue] = useState();
  const [playerTurn, setPlayerTurn] = useState(Math.random() >= 0.5);
  const [counter, setCounter] = useState(false);
  const [counter1, setCounter1] = useState(false);
  const [message, setMessage] = useState("");
  const [start, setStart] = useState(true);
  const [roomId, setRoomId] = useState();
  const [playerMelds, setPlayerMelds] = useState();
  const [playerInitialMove, setPlayerInitialMove] = useState(true);
  const [playerScore, setPlayerScore] = useState(0);
  const [botScore, setBotScore] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showScore, setShowScore] = useState(false);
  const [showWinPage, setShowWinPage] = useState(false);
  const [shuffledCard, setShuffledCard] = useState([]);
  const [deckCard, setDeckCard] = useState([]);
  const [firstPlayerCards, setFirstPlayerCards] = useState([]);
  const [secondPlayerCard, setSecondPlayerCards] = useState([]);
  const [loading, setLoading] = useState(true)
  const [totalPlayerScore, setTotalPlayerScore] = useState()
  const [totalBotScore, setTotalBotScore] = useState()
  const [playerResponseFromApi, setPlayerResponseFromApi] = useState()
  const [botResponseFromApi, setBotResponseFromApi] = useState()
  const [knock, setKnock] = useState(false)
  const [scoreDataFromAPi, setScoreDataFromAPI]=useState([])
  const [botMeldCards, setBotMeldCards] = useState()
  const [knockCardData, setknockCardData] = useState()
  const [round, setRound] = useState(1);
  const { isError } = useDisplayCardsQuery();
  const [fetchPlayersId] = useShowPlayersCardMutation()
  const [fetchUpdateId] = useUpdatePlayersCardMutation()
  const [isFlipped, setFlipped] = useState(false);


  useEffect(() => {
    console.log("scoreDataFromAPi", scoreDataFromAPi)
    setBotResponseFromApi(scoreDataFromAPi?.data?.data?.filter((item) => item.playerUserId == botId));
    setPlayerResponseFromApi(scoreDataFromAPi?.data?.data?.filter((item) => item.playerUserId != botId));
  }, [scoreDataFromAPi]);

  
  useEffect(() => {
    // console.count('hit')
    const playerScoreTotal = playerResponseFromApi?.map(d => d?.score + d?.bonusScore)
    const playerScoreSum = playerScoreTotal?.reduce((accumulator, currentValue) => accumulator + currentValue)
    setTotalPlayerScore(prev => prev = playerScoreSum)
    const botScoreTotal = botResponseFromApi?.map(d => d?.score + d?.bonusScore)
    const botScoreSum = botScoreTotal?.reduce((accumulator, currentValue) => accumulator + currentValue)
    setTotalBotScore(prev => prev = botScoreSum)

  }, [botResponseFromApi, playerResponseFromApi])

  const navigate = useNavigate();

  useEffect(() => {
    if (isError) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Session expired !",
        showConfirmButton: false,
        allowOutsideClick: false,
        footer: '<a class="btn btn-info" href=/login>Login Again</a>',
      });
    }
  }, [isError]);


  const userSprings = useSpring({
    from: {
      left: `-50vw`,
      top: `0`,
      transition: "0s ease-in-out",
      transform: "translate(-50%, 80%), rotate(0deg)",
      transform: "rotate(0deg)",
      position: "absolute",
    },

    to: {
      left: `35vw`,
      top: `30vh`,
      transition: "0.6s ease-in-out",
      transform: "translate(20%, 20%) rotate(30deg) rotateY(30deg)",
      width: "10vw",
      visibility: "visible",
      transformStyle: "preserve-3d"
    },
  });

  const [oppoSprings, api] = useSprings(
    deckPileNewLength ?? 31,
    () => ({
      from: {
        left: `-50vw`,
        top: `0`,
        transition: "0s ease-in-out",
        transform: "translate(-50%, 80%), rotate(0deg)",
        transform: "rotate(0deg)",
        position: "absolute",
      },

      to: {
        left: `39.2vw`,
        top: `-46vh`,
        transition: "0.6s ease-in-out",
        transform: "rotate(-30deg)",
        // transform: 'translate(20%, 20%) rotate(-30deg)',
        width: "8vw",
        visibility: "visible",
        transformStyle: "preserve-3d"
      },
    }),

    []
  );

  const springs = useSpring({
    from: {
      left: `0`,
      top: `-45vh`,
      transition: "0 ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
    },

    to: {
      left: `11vw`,
      top: `-46.5vh`,
      transition: "0.4s ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
      borderRadius: "10px",
    },
  });

  const springsBot = useSpring({
    from: {
      left: `0`,
      top: `0`,
      transition: "0.4s ease-in-out",
      transform: "rotate(10deg)",
      width: "10vw",
    },
    to: {
      left: `11vw`,
      top: `39vh`,
      transition: "0.3s ease-in-out",
      transform: "rotate(0deg)",
      width: "10vw",
      borderRadius: "10px",
    },
  });

  const discardUserSprings = {
    left: `35vw`,
    top: `25vh`,
    transition: "0.5s ease-in-out",
    transform: "translate(20%, 100%) rotate(30deg)",
    width: "8vw",
  };

  const discardBotSprings = {
    left: `39vw`,
    top: `-47vh`,
    transition: "0.4s ease-in-out",
    transform: "rotate(-30deg)",
    width: "8vw",
  };

  let userName = localStorage.getItem("userName");
  // start socket
  const accessToken = localStorage.getItem("token");
  let userId = localStorage.getItem("userId");

  // useEffect(() => {
  //   try {
  //     const connect = new HubConnectionBuilder()
  //       .withUrl(`${process.env.REACT_APP_API_KEY}/gameHub?access_token=${accessToken}`, {
  //         accessTokenFactory: () => accessToken,
  //         skipNegotiation: true,
  //         transport: HttpTransportType.WebSockets,
  //       })
  //       .withAutomaticReconnect()
  //       .build();

  //     setConnection(connect);
  //   } catch (err) {
  //     console.log("invoking Error", err);
  //   }
  // }, []);

  useEffect(() => {
    try {
        const connect = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_API_KEY}/gameHub`, {
                accessTokenFactory: () => accessToken,
                // skipNegotiation: true,
                transport: HttpTransportType.LongPolling,
            })
            .withAutomaticReconnect()
            .build();
        setConnection(connect);

    } catch (err) {
        console.log("invoking Error", err);
    }
}, []);

  useEffect(() => {
    if (connection) {
      connection
        .start()
        .then(() => {
          invokeConnection();
        })
        .catch((error) => console.log(error));
    }
    getData();
  }, [connection, playerMelds]);

  const gameNames = {
    RoomId: "", // Replace with the actual room ID
    GameName: "GinRummy",
    UserId1: userId,
    UserName1: userName,
    UserId2: "Bot123",
    UserName2: "B", //1D0BBABA-CC86-4457-B8FC-9E4E9C7B8EEA

  };


  async function invokeConnection() {
    try {
      if (roomId) {
        setPlayerTurn(true)
        setPlayerInitialMove(false)
        console.log("roomdddddd", roomId)
        const data = await fetchPlayersId(roomId)
        // setCardData(data?.data?.data);
        setShuffledCard(data?.data?.data?.deckCard);
        setDeckCard(data?.data?.data?.openCard);
        setSecondPlayerCards(data?.data?.data?.secondPlayerCard);
        console.log("data?.roomId", deckCard)
        setRoomId(data?.roomId);
        const melds = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.firstPlayerCards, data.roomId);
        const bot_melds = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.secondPlayerCard, data.roomId);
        const pickUpCard = await connection.invoke("PickUpCardByBot", data?.data?.data?.secondPlayerCard, data?.data?.data?.deckCard[0], data.roomId);
        // const thrownCard = await connection.invoke("ThrowCardByBot", data?.data?.data?.secondPlayerCard, data.roomId);
        console.log("bot_melds", bot_melds?.data?.data?.playerMeldCard)
        setBotMeldCards(bot_melds?.data?.data?.playerMeldCard)
        setPlayerMelds(melds?.data?.data);
        setFirstPlayerCards(melds?.data?.data.playerCards);
        setBotDeadValue(bot_melds?.data?.data?.deadwood);
        setDeadValue(melds?.data?.data?.deadwood);
        setBotPickData(pickUpCard);

      } else {
        const data = await connection.invoke("CardDistributed", gameNames);
        console.log("datadata", data)
        // setCardData(data?.data?.data);
        setShuffledCard(data?.data?.data?.suffledCard);
        setDeckCard(data?.data?.data?.deckCard);
        setSecondPlayerCards(data?.data?.data?.secondPlayerCard);
        setRoomId(data?.roomId);
        console.log("checksdsdsds", data?.data?.data?.firstPlayerCards, data.roomId)
        const melds = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.firstPlayerCards, data.roomId);
        console.log("meldssssvsCOmputer", melds)
        const bot_melds = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.secondPlayerCard, data.roomId);
        const pickUpCard = await connection.invoke("PickUpCardByBot", data?.data?.data?.secondPlayerCard, data?.data?.data?.deckCard[0], data.roomId);
        // const thrownCard = await connection.invoke("ThrowCardByBot", data?.data?.data?.secondPlayerCard, data.roomId);
        setBotMeldCards(bot_melds?.data?.data?.playerMeldCard)
        setPlayerMelds(melds?.data?.data);
        setFirstPlayerCards(melds?.data?.data.playerCards);
        setBotDeadValue(bot_melds?.data?.data?.deadwood);
        setDeadValue(melds?.data?.data?.deadwood);
        setBotPickData(pickUpCard);
        saveCard(melds?.data?.data.playerCards, data?.data?.data?.secondPlayerCard, data?.data?.data?.suffledCard, data?.data?.data?.deckCard, data?.roomId, "save")
      }

    } catch (err) {
      console.error("Error invoking CardDistributed: " + err);
    }
  }
  console.log("firstPlayerCardsAFterInvoke", firstPlayerCards)
  useEffect(() => {
    const storedRoomId = localStorage.getItem('roomId');
    console.log("storedRoomId", storedRoomId)
    if (!storedRoomId || storedRoomId == "undefined") {
      localStorage.setItem("roomId", roomId);
    } else {
      setRoomId(storedRoomId);
    }
  }, [roomId]);

  const saveCard = (firstP, secondP, shuffledP, deckP, roomKey, type) => {
    const firstPlayerCardsId = firstP?.map((d) => d?.id)
    const secondPlayerCardsId = secondP?.map(d => d?.id)
    const openedCardId = deckP?.map(d => d?.id)
    const deckCardsId = shuffledP?.map(d => d?.id)
    const apiResponse = async () => {
      const transformedData = {
        openedCard: openedCardId.join(','),
        playerCard1: firstPlayerCardsId.join(','),
        playerCard2: secondPlayerCardsId.join(','),
        DeckCards: deckCardsId.join(','),
        player1ModifiedDate: new Date(),
        player2ModifiedDate: new Date(),
        roomId: roomKey,
        isGameEnd: false,
        gameEndDate: new Date()
      };

      if (type == "save") {

        await savePlayerCards(transformedData)
      } else {
        const updateData = await fetchUpdateId(transformedData)
        console.log("updateData", updateData)
      }
    }
    apiResponse()
  }
  const getData = async () => {
    let Meldstyle = [];
    if (connection) {
      // console.log("playerMelds", playerMelds);
      if (playerMelds?.playerMeldCard) {
        playerMelds?.playerMeldCard?.forEach((item, index) => {
          Meldstyle?.push({ i: index, style: "type1" });
        });
        setBorderI(Meldstyle);
      }
      Meldstyle = [];
    }
  };

  const trail = useTrail(oppoCardLength ? 11 : 10, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    config: { duration: 150 },
    from: { transform: "translateX(-100%)" },
  });

  const trail2 = useTrail(cardLength ? 11 : 10, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    display: show ? "block" : "none",
    config: { duration: 150 },
    from: { display: "none" },
  });

  const trail3 = useTrail(deckPileNewLength ?? 31, {
    transform: show ? "translateX(0)" : "translateX(-100px)",
    opacity: show ? 1 : 0,
    display: show ? "block" : "none",
    config: { duration: 150 },
  });

  const Card = ({ card, style }) => (
    <animated.div style={style} className="card">
      <img src={card} />
    </animated.div>
  );

  // user playcard discard function************
  const handler = async (index, id) => {
    try {
      if (firstPlayerCards.length == 11) {
        console.log("indexComing", index, id)
        const element = firstPlayerCards[index];
        console.log("ele3mnt", element)
        setAnimatedI(id);
        setTimeout(async () => {
          setCardLength(false);
          setDeckCard([...deckCard, element]);
          let updatedDeckCards = []
          updatedDeckCards = ([...deckCard, element])
          console.log("updatedDeckcARD", updatedDeckCards)
          let discardedCard = cloneDeep(firstPlayerCards);
          // setFirstPlayerCards((current) => current.filter((item) => item.id !== id));
          // setDeckCard((current) => current.filter((item) => item.id !== ele.id));
          discardedCard = discardedCard?.filter((item, i) => index != i);
          console.log("discardedCardhandler", discardedCard)
          // discardedCard?.deckCard?.push(element);
          // setCardData(discardedCard);
          const deadWoodPlayer = await connection.invoke("GetGinMeldsFromCard", discardedCard, roomId);
          console.log("cardsTOSHOW2", deadWoodPlayer?.data?.data)
          setPlayerMelds(deadWoodPlayer?.data?.data);
          setDeadValue(deadWoodPlayer?.data?.data?.deadwood);
          setFirstPlayerCards(deadWoodPlayer?.data?.data?.playerCards)
          const pickUpCard = await connection.invoke("PickUpCardByBot", secondPlayerCard, element, roomId);
          setBotPickData(pickUpCard);
          knockCardData?.cardIndex ? setPlayerTurn(true) : setPlayerTurn(false)
          setStart(false);
          saveCard(deadWoodPlayer?.data?.data?.playerCards, secondPlayerCard, shuffledCard, updatedDeckCards, roomId, "update")
        }, 300);
        console.log("playerTurnAfterhandler", playerTurn)
      } else {
        return false;
      }
    }
    catch {
      setPlayerTurn(true)
    }
  };

  // right userdeck card discard function************
  const discardedPileHandler = async (id) => {
    setPlayerInitialMove(false);
    setCardLength(true);
    if (firstPlayerCards.length == 10) {
      console.log("dfsfdssfd", roomId)
      const ele = deckCard[deckCard.length - 1];
      console.log("eleeeee", ele)
      setAnimatedI4(id);
      const picked_card = cloneDeep(firstPlayerCards);
      setTimeout(async () => {
        const selectedDeckCard = deckCard?.filter((item) => item.id !== ele.id)
        console.log("selectedDeckCard", selectedDeckCard)
        setDeckCard((current) => current.filter((item) => item.id !== ele.id));
        // setFirstPlayerCards([...firstPlayerCards, ele]);
        // picked_card.deckCard = picked_card.deckCard.slice(0, picked_card.deckCard.length - 1);
        picked_card.push(ele);
        const discardedCards = await connection.invoke("GetGinMeldsFromCard", picked_card, roomId);
        console.log("cardsTOSHOW", discardedCards?.data?.data)
        setknockCardData(discardedCards?.data?.data?.knockCard)
        // picked_card.firstPlayerCards = discardedCards?.data?.data.playerCards;
        setFirstPlayerCards(discardedCards?.data?.data.playerCards);
        // setCardData(picked_card);
        setDeadValue(discardedCards?.data?.data?.deadwood);
        setPlayerMelds(discardedCards?.data?.data);
        saveCard(discardedCards?.data?.data.playerCards, secondPlayerCard, shuffledCard, selectedDeckCard, roomId, "update")
      }, 400);
    }
  };


  //left carddeck pile for user function************
  const deckPileHandler = async (id) => {
    const picked_card = cloneDeep(firstPlayerCards);
    const ele = shuffledCard[shuffledCard.length - 1];
    const selectedShuffledCard = shuffledCard.filter((item) => item.id !== ele.id)
    if (firstPlayerCards?.length == 10 && !playerInitialMove) {
      setAnimatedI2(id);
      setFlipped(true);
      setTimeout(async () => {
        setShuffledCard((current) => current.filter((item) => item.id !== ele.id));
        setCardLength(true);
        picked_card.push(ele);
        const discardedCards = await connection.invoke("GetGinMeldsFromCard", picked_card, roomId);
        setknockCardData(discardedCards?.data?.data?.knockCard)
        console.log("cardsTOSHOW1", discardedCards?.data?.data)
        setFirstPlayerCards(discardedCards?.data?.data?.playerCards);
        const deckPileLength = picked_card?.length - 1;
        setDeckPileNewLength(deckPileLength);
        setDeadValue(discardedCards?.data?.data?.deadwood);
        setPlayerMelds(discardedCards?.data?.data);
        saveCard(discardedCards?.data?.data.playerCards, secondPlayerCard, selectedShuffledCard, deckCard, roomId, "update")
        setFlipped(false);
        setAnimatedI2(null);
      }, 2000);
    } else {
      return false;
    }
  };

  function getSRC(cardN, cardS) {
    if (cardN && cardS) {
      const url = cardImages.find((o) => o.cardName.replace(/ /g, '') == cardN.replace(/ /g, '') && o.cardSuit.replace(/ /g, '') == cardS.replace(/ /g, ''));
      return url?.img;
    }
  }

  const botHandler = async (data) => {
    setCounter1(!counter1);
    setPlayerInitialMove(false);
    setOppoCardLength(false);
    const thrownCard = await connection.invoke("ThrowCardByBot", data, roomId);
    setAnimatedI6(true);
    const deadWoodPlayer = await connection.invoke("GetGinMeldsFromCard", thrownCard?.data?.playerCards, roomId);
    console.log("deadWooDapleyr", deadWoodPlayer?.data?.data)
    setBotDeadValue(deadWoodPlayer?.data?.data?.deadwood);
    // if (thrownCard?.data) {
    setDeckCard((prevState) => [...prevState, thrownCard?.data?.playerMeldCard[0]]);
    // const updatedDeckCards = [...deckCard, thrownCard?.data?.playerMeldCard[0]]

    setTimeout(() => {
      const temp_copy = secondPlayerCard;
      setSecondPlayerCards(thrownCard?.data?.playerCards);
      setPlayerTurn(true);
    }, 1500);
    const updatedDeckCards = [thrownCard?.data?.playerMeldCard[0]]
    console.log("updatedeckCardsFORBOT", updatedDeckCards)
    saveCard(firstPlayerCards, thrownCard?.data?.playerCards, shuffledCard, updatedDeckCards, roomId, "update")
    if (deadWoodPlayer?.data?.data?.deadwood <= 10) {
      botKnockButton(deadWoodPlayer?.data?.data?.deadwood);
    }
    // }
  };
  // Right
  const discardedPileBotHandler = async () => {
    if (secondPlayerCard?.length == 10) {
      setAnimatedI5(deckCard[deckCard.length - 1].id);
      const ele = deckCard[deckCard.length - 1];
      setOppoCardLength(true);
      const bot_picked_card = cloneDeep(secondPlayerCard);
      setTimeout(async () => {
        setDeckCard((current) => current.filter((item) => item.id !== ele.id));
        const selectedDeckCard = deckCard?.filter((item) => item.id !== ele.id)
        console.log("updatedeckCardsFORBOT1", selectedDeckCard)
        bot_picked_card.push(ele);
        const discardBot = await connection.invoke("GetGinMeldsFromCard", bot_picked_card, roomId);
        setSecondPlayerCards(discardBot?.data?.data?.playerCards);
        setBotDeadValue(discardBot?.data?.data?.deadwood);
        saveCard(firstPlayerCards, discardBot?.data?.data?.playerCards, shuffledCard, selectedDeckCard, roomId, "update")
      }, 2000);
      setTimeout(async () => {
        await botHandler(bot_picked_card);
      }, 4000);
      setCardLength(false);
    }
  };

  // LEFT for Bot
  const deckPileBotHandler = async (e, index) => {
    setCounter(!counter);
    if (secondPlayerCard?.length == 10) {
      setOppoCardLength(true);
      setCardLength(false);
      const bot_picked_card = cloneDeep(secondPlayerCard);
      const ele = shuffledCard[shuffledCard.length - 1];
      setShuffledCard((current) => current.filter((item) => item.id !== ele.id));
      const selectedShuffledCard = shuffledCard.filter((item) => item.id !== ele.id)
      setTimeout(async () => {
        bot_picked_card.push(ele);
        const discardBot = await connection.invoke("GetGinMeldsFromCard", secondPlayerCard, roomId);
        console.log("discardBotdiscardBot", discardBot?.data?.data)
        setSecondPlayerCards(discardBot?.data?.data?.playerCards);
        setBotDeadValue(discardBot?.data?.data?.deadwood);
        saveCard(firstPlayerCards, discardBot?.data?.data?.playerCards, selectedShuffledCard, deckCard, roomId, "update")
      }, 2000);
      setTimeout(async () => {
        await botHandler(bot_picked_card);
      }, 4000);
    }
  };

  const passTurn = () => {
    setMessage("pass");
    setPlayerTurn(true);
  };

  useEffect(() => {
    setShow(true);
    const getBotResponse = async () => {
      if (!playerTurn && botPickData) {
        if (botPickData?.data == true) {
          //  RIGHT
          await discardedPileBotHandler();
        } else {
          start
            ? setTimeout(() => {
              passTurn();
            }, 2000)
            : await deckPileBotHandler();
          setStart(false);
        }
      }
    };
    if (!playerTurn) {
      setTimeout(() => {
        getBotResponse();
      }, 2000);
    }
  }, [playerTurn]);

  useEffect(() => {
    setAnimatedI3(true);
  }, [counter]);
  useEffect(() => {
    setAnimatedI(true);
  }, [counter1]);

  const passhandler = () => {
    setPlayerTurn(false);
    setPlayerInitialMove(true);
  };

  async function fetchData(){
    const scoreDataa= await fetch(`${process.env.REACT_APP_API_KEY}/GameScore/GetGameScore?RoomId=${roomId}`,{ headers: {
      "Content-Type": "application/json",
      "Authorization" : `Bearer ${accessToken}`
    },}).then((res)=>res.json())
    console.log("scoreDataa", scoreDataa)
    setScoreDataFromAPI(scoreDataa)
    console.log("scoreDataa",scoreDataFromAPi)
  }


  const scoreData = [
    {
      roomId: roomId,
      gameName: gameName,
      playerUserId: userId, // Mention UserId
      round: "knock",
      score: 0,
      bonusScore: 0,
      gameRound: 1,
    },
    {
      roomId: roomId,
      gameName: gameName,
      playerUserId: botId, // Mention Bot Id
      round: "knock",
      score: 0,
      bonusScore: 0,
      gameRound: 1,
    },
  ];

  const botKnockButton = async (botdeadval) => {
    console.log("botdeadval", botdeadval)
    scoreData[0].bonusScore = 0;
    scoreData[0].score = 0;
    scoreData[1].bonusScore = 0;
    scoreData[1].score = 0;
    scoreData[0].gameRound = round;
    scoreData[1].gameRound = round;
    const difference = deadValue - botdeadval;
    // console.log("difference by bot", difference)
    if (difference < 0) {
      scoreData[1].score = 0;
      // const underCut = Math.abs(difference) + 25;
      scoreData[0].bonusScore = 25;
      scoreData[0].score = Math.abs(difference)
      // setBotScore(0);
      setPlayerScore({ score: scoreData[0].score, undercut: scoreData[0].bonusScore });
      setBotScore({ score: 0, undercut: 0 });
    } else if ((difference == 0)) {
      scoreData[0].score = 0;
      scoreData[1].score = 0;
      scoreData[0].bonusScore = 0;
      scoreData[1].bonusScore = 0;
      setBotScore({ score: 0, undercut: 0 });
      setPlayerScore({ score: 0, undercut: 0 });
    }
    // else if (botdeadval == 0) {
    //   scoreData[0].score = 0;
    //   scoreData[1].score = Math.abs(difference);
    //   scoreData[0].bonusScore = 0;
    //   scoreData[1].bonusScore = 25;
    //   setPlayerScore({ score: 0, undercut: 0 });
    //   setBotScore({ score: scoreData[1].score, gin: scoreData[1].bonusScore });
    // }
    // else if (botMeldCards.length == 11) {
    //   scoreData[0].score = 0
    //   scoreData[1].score = Math.abs(difference);;
    //   scoreData[0].bonusScore = 0;
    //   scoreData[1].bonusScore = 50;
    //   setPlayerScore({ score: 0, undercut: 0 });
    //   setBotScore({ score: scoreData[1].score, bigGin: scoreData[1].bonusScore });
    // }

    else {
      scoreData[1].score = Math.abs(difference);
      scoreData[1].bonusScore = 0
      setBotScore({ score: scoreData[1].score, undercut: 0 });
      setPlayerScore({ score: 0, undercut: 0 });
    }
    console.log("scoreDatascoreData", scoreData)
    const scoreApi = await createScore(scoreData);
    console.log("scoreApiscoreApi", scoreApi)
    // setPlayerScore({ score: scoreData[0].score, undercut: scoreData[0].bonusScore });
    setRound(round + 1);
    console.log("roomIdroomIdroomId", roomId)
    await fetchData()
    setShowModal(true);
    // setKnockTrue(true);
    setPlayerTurn(true);
    setShow(false);
    // setCardData([])
    setKnock(true)
    setShuffledCard([]);
    setDeckCard([]);
    setFirstPlayerCards([]);
    setSecondPlayerCards([]);
  };

  const knockBtn = async () => {
    setTimeout(async () => {
      setCardLength(false);
      setDeckCard([...deckCard, knockCardData]);
      let discardedCard = cloneDeep(firstPlayerCards);
      discardedCard = discardedCard?.filter((item, i) => item.id != knockCardData.id);    
      const deadWoodPlayer = await connection.invoke("GetGinMeldsFromCard", discardedCard, roomId);
      console.log("cardsTOSHOW3", deadWoodPlayer?.data?.data?.playerMeldCard)
      setPlayerMelds(deadWoodPlayer?.data?.data);
      setDeadValue(deadWoodPlayer?.data?.data?.deadwood);
      setFirstPlayerCards(deadWoodPlayer?.data?.data?.playerCards)
      setPlayerTurn(true);
      scoreData[0].bonusScore = 0;
      scoreData[0].score = 0;
      scoreData[1].bonusScore = 0;
      scoreData[1].score = 0;
      scoreData[0].gameRound = round;
      scoreData[1].gameRound = round;
      const difference = botDeadValue - deadWoodPlayer?.data?.data?.deadwood;
      if (difference < 0) {
        scoreData[0].score = 0
        scoreData[1].score = Math.abs(difference);
        scoreData[1].bonusScore = 25;
        setPlayerScore({ score: 0, undercut: 0 });
        setBotScore({ score: scoreData[1].score, undercut: scoreData[1].bonusScore });
      } else if ((difference == 0)) {
        scoreData[0].score = 0;
        scoreData[1].score = 0;
        scoreData[0].bonusScore = 0;
        scoreData[1].bonusScore = 0;
        setPlayerScore({ score: 0, undercut: 0 });
        setBotScore({ score: 0, undercut: 0 });
      }
      else if (deadWoodPlayer?.data?.data?.deadwood == 0) {
        scoreData[0].score = Math.abs(difference);
        scoreData[1].score = 0;
        scoreData[0].bonusScore = 25;
        scoreData[1].bonusScore = 0;
        setPlayerScore({ score: scoreData[0].score, gin: scoreData[0].bonusScore });
        setBotScore({ score: 0, undercut: 0 });
      }
  
      else if (deadWoodPlayer?.data?.data?.playerMeldCard.length == 11) {
        scoreData[0].score = Math.abs(difference);
        scoreData[1].score = 0;
        scoreData[0].bonusScore = 50;
        scoreData[1].bonusScore = 0;
        setPlayerScore({ score: scoreData[0].score, bigGin: scoreData[0].bonusScore });
        setBotScore({ score: 0, undercut: 0 });
      }
  
      else {
        scoreData[0].score = Math.abs(difference);
        scoreData[0].bonusScore = 0
        setPlayerScore({ score: scoreData[0].score, undercut: 0 });
        setBotScore({ score: 0, undercut: 0 });
      }
  
      console.log("scoreDatascoreDatascoreData", scoreData)
      setStart(false);
    }, 300);

   
    const scoreAPi = await createScore(scoreData);
    console.log("scoreApiscoreApiP", scoreAPi)
    // setBotScore({ score: scoreData[1].score, undercut: scoreData[1].bonusScore });
    setRound(round + 1);
    console.log("roomIdroomIdroomIdroomId", roomId)
    await fetchData()

    setTimeout(() => {
      setShow(false);
      setShowModal(true);
      setShuffledCard([]);
      setKnock(true)
      setDeckCard([]);
      setFirstPlayerCards([]);
      setSecondPlayerCards([]);
    }, 2000)


    // setCardData([])
  };

  const scoreBtn = async () => {
    console.log("callleedd")
    setShowScore(true);
  };
  console.log("knockCardData", knockCardData)
  useEffect(() => {
    // setCardData(cardData);
    // setShuffledCard(cardData.suffledCard)

    setAnimatedI4("");
    setAnimatedI2("");
    setAnimatedI("");
    setAnimatedI3(false);
    setAnimatedI5("");
    setAnimatedI6(false);
    setPlayerMelds([]);
    setDeadValue(deadValue);
  }, [firstPlayerCards, secondPlayerCard,]);

  const continueButton = async (item) => {
    setPlayerInitialMove(true);
    setShowModal(item);
    setShow(true);
    setCardLength(false)
    const data = await connection.invoke("CardDistributed", gameNames);

    // setCardData(data?.data?.data);
    const firstPlayerMeld = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.firstPlayerCards, roomId);
    const secondPlayerMeld = await connection.invoke("GetGinMeldsFromCard", data?.data?.data?.secondPlayerCard, roomId);
    setPlayerMelds(firstPlayerMeld?.data?.data);
    setDeadValue(firstPlayerMeld?.data?.data?.deadwood);
    setBotDeadValue(secondPlayerMeld?.data?.data?.deadwood);
    setShuffledCard(data?.data?.data?.suffledCard);
    setDeckCard(data?.data?.data?.deckCard);
    setFirstPlayerCards(data?.data?.data?.firstPlayerCards);
    setSecondPlayerCards(data?.data?.data?.secondPlayerCard);
  };

  const exitGame = () => {

    Swal.fire({
      title: "Are you sure?",
      text: "Want to exit!",
      icon: "warning",
      cancelButtonColor: "#DD6B55",
      confirmButtonColor: "#DD6B55",
      showConfirmButton: true,
      showDenyButton: true,
      denyButtonText: "Cancel",
      confirmButtonText: "Exit",
      focusCancel: true,
    }).then(function ({ isConfirmed }) {
      if (isConfirmed) {
        navigate("/gingame");
        localStorage.removeItem('roomId')
      } else {
        console.log("no");
      }
    });
  };

  useEffect(() => {
    if (firstPlayerCards && secondPlayerCard) { setLoading(false) }
  }, [firstPlayerCards, secondPlayerCard])


  const getTimeout = (s) => {
    // console.log("s",s)

    if (s == 0) {
      setPlayerTurn(false)
    }
  }


  return (
    <>
      {loading ? <Loader /> : <div className="ginGamePage d-flex">
        <div className="leftSection">
          <div className="pageControl">
            {/* <Link to="/gingame" className='btn-container border-0 bg-transparent'>
            <img src={ExitBtn} className="img-fluid" alt="toggle image" />
</Link> */}
            <button className="btn toggleBtn" >
              {/* <img src={ToggleButton} className="img-fluid" alt="toggle image" /> */}
              <img src={ExitBtn} className="img-fluid" alt="toggle image" onClick={exitGame} />
              {/* <img src={ExitBtn} className="img-fluid" alt="toggle image" onClick={scoreBtn} /> */}
            </button>
          </div>

          <div className="userInfo">
            <div className="userProfile">
              <img src={PlayerBoard} className="img-fluid" alt="" />
              <div className="userImage">
                <img src={User} className="img-fluid" alt="" />
                {playerTurn && !showModal && <Timer getTimer={(s) => getTimeout(s)} />}
              </div>
              <div className="userName text-capitalize">
                <span>{userName}</span>
              </div>

              <div className="playerScore">
                <img src={PlayerBoard} className="img-fluid" alt="" />
                <div className="scoreCard">
                  <p className="score">{knock ? totalPlayerScore : "0"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="game-board">
          <div className="card-container-opponent ">
            <div className="opptGameBoard text-center w-100">
              <img src={OpptGameBoard} className="img-fluid" alt="" />
            </div>
            <div className={oppoCardLength ? `pickedOpponentCards` : `opponentCards`}>
              {secondPlayerCard &&
                trail?.map(({ transform, opacity }, index) => (
                  <animated.img
                    id={secondPlayerCard[index]?.id}
                    src={cardBackCover[0]?.front}
                    // src={getSRC(secondPlayerCard[index]?.cardName, secondPlayerCard[index]?.cardSuit)}
                    style={
                      animatedI6 && index == 9
                        ? springsBot
                        : { opacity, borderRadius: "10px", position: "absolute", left: `calc(10vw * ${oppoCardLength ? index / 2.32 : index / 2.12} - 50vw/2)` }
                    }
                    className={`card opponent-card-${index + 1}`}
                  />
                ))}
            </div>
          </div>
          <div className="middle-container">
            <div className="card-stack" style={{ position: "relative" }}>
              {shuffledCard &&
                trail3.map(({ transform, opacity, display }, index) => (
                  // FOR MIDDLE LEFT ONE
                  <animated.img
                    className={`card stack-card-${index + 1}`}
                    style={
                      animatedI2 == shuffledCard[index]
                        ? userSprings
                        : animatedI3 && index == 0
                          ? oppoSprings[index]
                          : { opacity, position: "absolute", transform: `translate(-${(index * 6) / 4}px, -${(index * 6) / 4}px)`, borderRadius: "10px" }
                    }
                    src={isFlipped && animatedI2?.id == shuffledCard[index]?.id ? getSRC(shuffledCard[shuffledCard.length - 1]?.cardName, shuffledCard[shuffledCard.length - 1]?.cardSuit) : cardBackCover[index]?.front}
                    onClick={playerTurn ? () => deckPileHandler(shuffledCard[index]) : () => false}
                  />
                ))}
            </div>

            <div className="gameImage">
              <div className={!playerTurn ? "d-block oppoTurn mb-3" : "d-none oppoTurn mb-3"}>
                <p className="mb-0">Bot Turn</p>
              </div>
              <img src={GinGameImage} className="img-fluid" alt="" />
              <div className={playerTurn ? "d-block oppoTurn mt-3 text-nowrap" : "d-none oppoTurn mt-3 text-nowrap"}>
                {playerInitialMove ? (
                  <p className="mb-0">Want to take the upcard? </p>
                ) : (
                  <p className="mb-0">Your Turn {firstPlayerCards?.length == 11 ? "Throw" : "Pick"} a Card.</p>
                )}
              </div>
            </div>

            {/* FOR MIDDLE RIGHT ONE */}
            <div className="discarded-card">
              {deckCard &&
                deckCard.map((item, index) => {
                  return (
                    <img
                      src={getSRC(item?.cardName, item?.cardSuit)}
                      style={
                        animatedI4 == item.id
                          ? discardUserSprings
                          : animatedI5 == item.id
                            ? discardBotSprings
                            : { position: "absolute", top: `60%`, borderRadius: "10px" }
                      }
                      alt=""
                      onClick={playerTurn ? () => discardedPileHandler(item.id) : () => false}
                    />
                  );
                })}
            </div>
          </div>

          <div className="bottomCard-container" style={{ display: "flex" }}>
            <div className="gameBoard text-center w-100">
              <img src={GameBoard} className="img-fluid" alt="" />
            </div>
            <div className={cardLength ? `pickedUserCards` : `userCards`}>
              {console.log("firstPlayerCards", firstPlayerCards)}
              {firstPlayerCards &&
                firstPlayerCards?.length &&
                trail2.map(({ transform, opacity, key }, index) => (
                  // LAST ROW
                  <animated.img
                    key={key}
                    id={firstPlayerCards[index]?.id}
                    style={
                      animatedI == firstPlayerCards[index]?.id
                        ? springs
                        : { opacity, borderRadius: "10px", position: "absolute", left: `calc(10vw * ${cardLength ? index / 2.32 : index / 2.12} - 50vw/2)` }
                    }
                    className={borderI[index]?.i == index ? `meld-${borderI[index].style} card` : "card"}
                    src={getSRC(firstPlayerCards[index]?.cardName, firstPlayerCards[index]?.cardSuit)}
                    onClick={playerTurn ? () => handler(index, firstPlayerCards[index]?.id) : () => false}
                  />
                ))}
            </div>
          </div>
        </div>

        <GinGameKnock
          totalBotScore={totalBotScore}
          totalPlayerScore={totalPlayerScore}
          continueButton={continueButton}
          showModal={showModal}
          botDeadValue={botDeadValue}
          deadValue={deadValue}
          knockTrue={knockTrue}
          setShow={setShow}
          playerScore={playerScore}
          botScore={botScore}

        />

        {showScore && <GinGameScore showScore={showScore} setShowScore={setShowScore} setTotalPlayerScore={setTotalPlayerScore}
          setTotalBotScore={setTotalBotScore} botResponseFromApi={botResponseFromApi} playerResponseFromApi={playerResponseFromApi}
          totalPlayerScore={totalPlayerScore} totalBotScore={totalBotScore}
        />}
        {showWinPage && <GinGameWinPage showWinPage={showWinPage} setShowWinPage={setShowWinPage} />}

        <div className="rightSection">
          <div className="opponentInfo">
            <div className={playerTurn ? "d-none" : "d-block"}>
              <p className={message ? "playerPass" : "oppo Pass"}>{message}</p>
            </div>

            <div className="userProfile">
              <img src={PlayerBoard} className="img-fluid" alt="" />
              <div className="userImage">
                <img src={User} className="img-fluid" alt="" />
              </div>
              <div className="userName">
                <span>Jarvis</span>
              </div>

              <div className="playerScore">
                <img src={PlayerBoard} className="img-fluid" alt="" />
                <div className="scoreCard">
                  {/* <p className="score text-muted">##</p> */}
                  {/* <p className="score text-muted">{botDeadValue}</p> */}
                  <p className="score">{knock ? totalBotScore : 0}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="deadwood">
            <div className="gameButtons">
              <div className={deadValue <= 10 ? "d-block" : "d-none"}>{playerTurn && knockCardData?.cardName && <Button onClick={knockBtn} btnName="Knock" />}</div>
              {playerTurn && round > 1 && <Button btnName="Score" onClick={scoreBtn} />}
            </div>
            {playerTurn && playerInitialMove && <Button btnName="Pass" onClick={passhandler} />}
            {/* {<Button btnName="Score" onClick={scoreHandler} />} */}

            <div className="deadwoodBoard">
              <Row className="customRow">
                <Col xs={12} className="text-center">
                  <div className="deadwoodHeader">
                    <span>Deadwood</span>
                  </div>
                </Col>
                <Col xs={6} className="text-center">
                  <div className="currDeadwood">
                    <span>{deadValue}</span>
                  </div>
                </Col>
                <Col xs={6} className="text-center">
                  <div className="currDeadwood">{deadValue <= 10 ? <span style={{ opacity: 1 }}>10</span> : <span style={{ opacity: 0.5 }}>10</span>}</div>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};
export default Cards;
